import { EyeOutlined, NodeIndexOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Col, Row, Tooltip } from 'antd';
import { Box, Text } from 'atoms';
// import { getUserType } from 'hooks/useAuth';

const DateFormat = 'DD-MM-YYYY';
// const TIME_FORMAT = 'hh:mm a';

function getLocalDate(date) {
	// console.log(moment(date).add(330, 'minutes').format(DateFormat));
	// console.log(moment.utc(date, 'MM/DD/YYYY HH:mm').toDate());

	if (date) {
		return moment(date).add(330, 'minutes').format(DateFormat);
	}
	return '';
}

// function getLocalTime(time) {
// 	if (time) {
// 		return moment(time).add(330, 'minutes').format(TIME_FORMAT);
// 	}
// 	return '';
// }

function getTripDuration(trip_duration_hours) {
	const duration = parseFloat(trip_duration_hours);
	const hours = Math.floor(duration);
	const minutes = Math.round((duration - hours) * 60);
	return `${hours} hrs ${minutes} mins`;
}

function getValidType(valid) {
	return valid === true ? 'Valid' : 'Invalid';
}

export const TripHistoryTableConfig = (get_location_history) => [
	{
		title: 'Trip ID',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		width: 70,
		render: (id) => <Text overFlow="hidden">{id || ''}</Text>,
	},
	{
		title: 'Project Name',
		dataIndex: 'project_location_code',
		key: 'project_name',
		width: 120,
		hidden: false,
		render: (project_location_code, record) => (
			<Text overFlow="hidden" style={{ minWidth: '110px' }}>
				{project_location_code || record?.project_name || ''}
			</Text>
		),
	},
	{
		title: 'Trip Type ',
		dataIndex: 'trip_type',
		key: 'trip_type',
		hidden: false,
		width: 80,
		render: (trip_type) => (
			<Text overFlow="hidden" style={{ minWidth: '70px' }}>
				{trip_type || ''}
			</Text>
		),
	},
	{
		title: 'Business Unit',
		dataIndex: 'city',
		key: 'city',
		width: 80,
		hidden: false,
		render: (city, record) => (
			<>
				<Text overFlow="hidden">{record?.business_unit_name || '-'}</Text>
				<Text overFlow="hidden">{`${city ? `(${city})` : ''}`}</Text>
			</>
		),
	},
	{
		title: 'Movement',
		dataIndex: 'info',
		key: 'movement',
		width: 100,
		hidden: false,
		render: (info) => {
			const isInterCity = info?.is_inter_city;
			const movementText = isInterCity ? 'Intercity' : 'Intracity';
			const backgroundColor = isInterCity ? '#FFDDB3D9' : '#C1DCFFD9';
			const color = '#000000';

			return (
				<Text
					overFlow="hidden"
					style={{
						minWidth: '70px',
						backgroundColor,
						color,
						padding: '4px 8px',
						borderRadius: '12px',
						fontSize: '12px',
						fontWeight: '500',
						textAlign: 'center',
						display: 'inline-block',
					}}
				>
					{movementText}
				</Text>
			);
		},
	},
	{
		title: 'Cilent Name',
		dataIndex: 'client_name',
		key: 'client_name',
		width: 120,
		hidden: false,
		render: (client_name) => (
			<Text overFlow="hidden" style={{ minWidth: '110px' }}>
				{client_name || ''}
			</Text>
		),
	},
	{
		title: 'Vendor Name ',
		dataIndex: 'vendor_name',
		key: 'vendor_name',
		width: 120,
		hidden: false,
		render: (vendor_name) => (
			<Text overFlow="hidden" style={{ minWidth: '110px' }}>
				{vendor_name || ''}
			</Text>
		),
	},
	{
		title: 'Vehicle Number',
		dataIndex: 'vehicle_number',
		key: 'vehicle_number',
		width: 90,
		hidden: false,
		render: (vehicle_number) => (
			<Text overFlow="hidden" style={{ minWidth: '80px' }}>
				{vehicle_number || ''}
			</Text>
		),
	},

	{
		title: 'Trip Date/Time',
		dataIndex: 'reporting_date',
		key: 'reporting_date',
		width: 120,
		hidden: false,
		render: (reporting_date, record) => {
			const reportingDateTime =
				record?.actual_reporting_time || record?.reporting_time || reporting_date;

			return (
				<Box>
					<Text overFlow="hidden" style={{ minWidth: '110px' }}>
						{getLocalDate(reportingDateTime).slice(0, 10)}
					</Text>

					<Text overFlow="hidden" style={{ minWidth: '110px' }}>
						{record?.trip_duration_hours
							? getTripDuration(record?.trip_duration_hours)
							: '-'}
					</Text>
				</Box>
			);
		},
	},

	{
		title: 'Source',
		dataIndex: 'source_entry',
		key: 'source_entry',
		width: 80,
		hidden: false,
		render: (source_entry) => (
			<Box>
				<Text overFlow="hidden">{source_entry}</Text>
			</Box>
		),
	},
	{
		title: 'Valid',
		dataIndex: 'is_valid',
		key: 'is_valid',
		width: 70,
		hidden: false,
		render: (is_valid) => (
			<Box>
				<Text overFlow="hidden">{getValidType(is_valid)}</Text>
			</Box>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		width: 80,
		render: (id, record) => {
			const location = typeof window !== 'undefined' ? window.location : { pathname: '' };
			return (
				<Row gutter={2} justify="space-between">
					{record?.client_name === 'Seven Eleven' && (
						<Col>
							<Tooltip title="Location History">
								<NodeIndexOutlined
									style={{ color: 'green', fontSize: '14px' }}
									onClick={() => get_location_history(record?.id)}
								/>
							</Tooltip>
						</Col>
					)}
					<Col>
						<Link
							to={{ pathname: `/trips/${id}/overview` }}
							state={{ from: location.pathname }}
						>
							<EyeOutlined />
						</Link>
					</Col>
				</Row>
			);
		},
	},
];
